import srLatnMessages from './messages/sr-latn.json';
import srMessages from './messages/sr.json';

export const messages = {
  'sr-latn': srLatnMessages,
  sr: srMessages,
};
